import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
    name: "farmer",
    initialState : {
        farmers: [],
    },
    reducers: {
        setFarmer: (state, action) => {
            state.farmers = action.payload;
        },
    },
});

export const { setFarmer } = slice.actions;
export default slice.reducer;